import React from 'react';
import Icon from '../Icon';
import CustomTooltip from '../../components/Tooltip';
import UserStore from '../../stores/UserStore';
import { I18nFormatter } from '../../utils/I18n/I18n';

export const renderCplAmount = (commissionContract, key) => {
    if (!commissionContract) return null;

    const cc = commissionContract && commissionContract.commission_contract ? commissionContract.commission_contract : commissionContract;
    const staticNames = (UserStore.getTranslation()?.offersPage?.offer) || {};

    const cplAmount = Number(cc?.cpl?.amount) || 0;
    const cplCurrency = cc?.cpl?.currency || cc?.promotion_cpl?.currency || '';
    const promoAmount = Number(cc?.promotion_cpl?.amount) || 0;

    if (promoAmount > 0) {
        return (
            <React.Fragment>
                {I18nFormatter.currency(cplAmount + promoAmount, cplCurrency)}&nbsp;
                <CustomTooltip id={key} theme={'white'} tooltip={(
                    <React.Fragment>
                        <p>{staticNames.commissionContract}: {I18nFormatter.currency(cplAmount, cplCurrency)}</p>
                        <p>{staticNames.promotionCommission}: {I18nFormatter.currency(promoAmount, cc?.promotion_cpl?.currency || cplCurrency)}</p>
                    </React.Fragment>
                )}>
                    <Icon name={'fa-arrow-up text-navy'} />
                </CustomTooltip>
            </React.Fragment>
        );
    }

    return I18nFormatter.currency(cplAmount, cplCurrency);
};

export const renderCps = (commissionContract, key) => {
    if (!commissionContract) return null;

    const cc = commissionContract && commissionContract.commission_contract ? commissionContract.commission_contract : commissionContract;
    const staticNames = (UserStore.getTranslation()?.offersPage?.offer) || {};
    const cps = Number(cc?.cps) || 0;
    const promoCps = Number(cc?.promotion_cps) || 0;
    const dynamicCps = cc?.dynamic_cps || {};
    const isDynamicEmpty = Array.isArray(dynamicCps)
        ? dynamicCps.length === 0
        : Object.keys(dynamicCps).length === 0;

    if (promoCps > 0) {
        return (
            <React.Fragment>
                {I18nFormatter.percentage(cps + promoCps)}&nbsp;
                <CustomTooltip id={key} theme={'white'} tooltip={(
                    <React.Fragment>
                        <p>{staticNames.commissionContract}: {I18nFormatter.percentage(cps)}</p>
                        <p>{staticNames.promotionCommission}: {I18nFormatter.percentage(promoCps)}</p>
                    </React.Fragment>
                )}>
                    <Icon name={'fa-arrow-up text-navy'} />
                </CustomTooltip>
            </React.Fragment>
        );
    }

    if (isDynamicEmpty) {
        return I18nFormatter.percentage(cps);
    }

    return Object.keys(dynamicCps).map((option, i) => (
        <p key={i}>{option} -> {I18nFormatter.percentage(dynamicCps[option])}</p>
    ));
};

export const renderCplAmountMin = (commissionContract, key) => {
    if (!commissionContract) return null;

    const cc = commissionContract && commissionContract.commission_contract ? commissionContract.commission_contract : commissionContract;
    const staticNames = (UserStore.getTranslation()?.offersPage?.offer) || {};
    const minAmount = Number(cc?.cpl_amount_min?.amount) || 0;
    const minCurrency = cc?.cpl_amount_min?.currency || '';

    if (minAmount > 0) {
        return (
            <React.Fragment>
                {I18nFormatter.currency(minAmount, minCurrency)}&nbsp;
                <CustomTooltip id={key} theme={'white'} tooltip={(
                    <React.Fragment>
                        <p>{staticNames.commissionContract}: {I18nFormatter.currency(minAmount, minCurrency)}</p>
                    </React.Fragment>
                )}>
                    <Icon name={'fa-arrow-to'} />
                </CustomTooltip>
            </React.Fragment>
        );
    }

    return I18nFormatter.currency(minAmount, minCurrency);
};